import { render, staticRenderFns } from "./ImageAndText.vue?vue&type=template&id=f0225a46&scoped=true&"
import script from "./ImageAndText.vue?vue&type=script&lang=js&"
export * from "./ImageAndText.vue?vue&type=script&lang=js&"
import style0 from "./ImageAndText.vue?vue&type=style&index=0&id=f0225a46&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0225a46",
  null
  
)

export default component.exports